export {
  mapDtoToEquipmentPage,
  mapDtoToEquipmentPoints,
  mapDtoToEquipmentTypes,
} from "./mappers";
export type { EquipmentsPageType } from "./types";
